import { render, staticRenderFns } from "./DesignPaperTiles.vue?vue&type=template&id=50a8ea0f&scoped=true&"
import script from "./DesignPaperTiles.vue?vue&type=script&lang=js&"
export * from "./DesignPaperTiles.vue?vue&type=script&lang=js&"
import style0 from "./DesignPaperTiles.vue?vue&type=style&index=0&id=50a8ea0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8ea0f",
  null
  
)

export default component.exports